import { AuthStore } from "../interfaceTypes";

export enum Auth_Action {
  SET_USER_LOADER = "setUserLoader",
  SET_IS_LOGGED_IN = "setIsLoggedIn",
  SET_LOGGED_IN_USER = "setLoggedInUser",
}

type LoggedInUser<T> = T;

export type AuthAction =
  | { type: Auth_Action.SET_IS_LOGGED_IN; isLoggedIn: boolean }
  | {
      type: Auth_Action.SET_LOGGED_IN_USER;
      loggedInUser: LoggedInUser<unknown>;
    }
  | { type: Auth_Action.SET_USER_LOADER; userLoader: boolean };

export const authStoreDefaultValue: AuthStore<unknown> = {
  isLoggedIn: false,
  userLoader: false,
  loggedInUser: null,
};

export const authReducer = (
  state: AuthStore<unknown>,
  action: AuthAction
): AuthStore<unknown> => {
  const { type } = action;

  switch (type) {
    case Auth_Action.SET_IS_LOGGED_IN: {
      return { ...state, isLoggedIn: action.isLoggedIn };
    }

    case Auth_Action.SET_LOGGED_IN_USER: {
      return { ...state, loggedInUser: action.loggedInUser };
    }

    case Auth_Action.SET_USER_LOADER: {
      return { ...state, userLoader: action.userLoader };
    }

    default:
      return state;
  }
};
